<template>
  <v-container>
    <perseu-card title="Idiomas">
      <v-btn color="secondary" slot="title-right" @click="create">
        Novo Idioma
      </v-btn>
      <v-flex slot="content">
        <v-switch v-model="query.active" label="Ativos"></v-switch>
        <v-data-table :items="items" :headers="headers" class="elevation-1">
          <template v-slot:item.actions="props">
            <v-btn small icon @click="edit(props.item)" color="secondary">
              <v-icon small>edit</v-icon>
            </v-btn>
          </template>
        </v-data-table>
      </v-flex>
    </perseu-card>
    <v-dialog v-model="dialog" v-if="dialog" width="600px">
      <form-langs
        @create="createdForm"
        @update="updatedForm"
        :value="item"
      ></form-langs>
    </v-dialog>
  </v-container>
</template>

<script>
import * as service from "@/services/langs-service";
export default {
  components: {
    "form-langs": () => import("@/components/Langs/Form"),
  },
  data: () => ({
    headers: [
      { text: "Nome", value: "name" },
      {
        text: "Ações",
        value: "actions",
        sortable: false,
        align: "start",
        width: 200,
      },
    ],
    items: [],
    item: {},
    dialog: false,
    query: {
      active: true,
    },
  }),
  watch: {
    query: {
      handler() {
        this.list();
      },
      deep: true,
    },
  },
  computed: {
    title() {
      return this.item._id ? "Editar idioma" : "Novo idioma";
    },
    editItem() {
      return this.item;
    },
  },
  methods: {
    async activeOrDeactivate(item, option) {
      try {
        this.$store.dispatch("loading/openDialog");
        item.active = option;
        await service.save(item);
        const index = this.findIndexItem(item);
        this.items.splice(index, 1);
      } catch (error) {
        this.$errorHandler(error);
      } finally {
        this.$store.dispatch("loading/closeDialog");
      }
    },
    async list() {
      try {
        this.$store.dispatch("loading/openDialog");
        let response = await service.findAll(this.query);
        this.items = response.data;
      } catch (error) {
        this.$errorHandler(error);
      } finally {
        this.$store.dispatch("loading/closeDialog");
      }
    },
    async create() {
      this.item = {};
      this.dialog = true;
    },
    createdForm(lang) {
      this.items.push(lang);
      this.dialog = false;
    },
    updatedForm() {
      this.dialog = false;
    },
    edit(item) {
      this.item = item;
      this.dialog = true;
    },
    findIndexItem(itemParam) {
      return this.items.findIndex((item) => item.id === itemParam.id);
    },
  },
  created() {
    this.list();
  },
};
</script>

<style></style>
